export * from './errCode';
export * from './welfare-task';
export * from './api';

export const getHost = () => {
  let host;

  if (process.env.isTest || process.env.NODE_ENV === 'development') {
    host = 'http://qbact.sparta.html5.qq.com';
  } else {
    host = 'https://qbact.html5.qq.com';
  }
  return host;
};

export const getHelpLink = () => {
  let host;

  if (process.env.isTest || process.env.NODE_ENV === 'development') {
    host = 'https://test.kuaibao.qq.com/view/2020hb?refer=kb_welfare_banner_help';
  } else {
    host = 'https://kuaibao.qq.com/view/2020hb?refer=kb_welfare_banner_help';
  }
  return host;
};

export const ACCOUNT = {
  STATUS: {
      	NORMAL: 0, // 正常
      	BLACK: 1, // 黑名单
      	NOT_MATCH_DEVICE: 3, // 设备绑定识别失败
      	TINAYU_BLACK: 5, // 天域高风险账号
      	IP_BLACK: 6, // 异常IP
  },
};

// 快报
const excitedVideoAdApiJsUrl = '//img.nfa.qq.com/ads-comp/excited-video-ad-api.e5aa6ddabba61dd9.js';
// 浏览器
const nfaMotivationJsUrl = '//img.nfa.qq.com/static-new/qb/js/nfa.motivation.js';
// 上报广告卡券
let reportUrl = '//report.nfa.qq.com/report';
let hostv2 = '//kuaibao.qq.com';
if (process.env.isTest || process.env.NODE_ENV === 'development') {
  reportUrl = '//testreport.nfa.qq.com/report';
  hostv2 = '//qbact.sparta.html5.qq.com';
}

const aegisOpts = {
  kb: {
    id: 3498,
  },
  qb: {
    id: 3499,
  },
};

export {
  excitedVideoAdApiJsUrl,
  nfaMotivationJsUrl,
  reportUrl,
  aegisOpts,
  hostv2,
};

export const TASK_EVOLVE_TYPE = {
  WELFARE_TASK_NOT_STARTED: 0,
  WELFARE_TASK_DOING: 1,
  WELFARE_TASK_DONE: 2,
  WELFARE_TASK_CANNOT_DOING: 3,
  WELFARE_TASK_ALL_DONE: 4,
  WELFARE_TASK_LOCKED_BY_GUID: 5, // 因单个设备登录多个账号锁定
  WELFARE_TASK_LOCKED_BY_QBID: 6, // 因单个账号登录多个设备锁定
};

export const BLACK_USER_DIALOG = {
  title: '系统提示',
  content: '单天单个账号单个设备只能参与一次福利任务，请切换原账号/原设备继续参与。切换登录路径：我的>设置>退出登录',
  confirm: '知道了',
};

export const NOVEL_WELFARE_PAGE_ADDR = 'qb://tab/feedschannel?component=FeedsNovelPage&module=novelsingletab&title=小说&tabId=112&currentId=187&ch=007330';

export const NOVEL_WELFARE_PAGE_ADDR_FOR_TASK = 'qb://tab/feedschannel?component=FeedsNovelPage&module=novelsingletab&title=小说&tabId=112&currentId=187&ch=005162&backupUrl=qb%3A%2F%2Fhome%2Ffeeds%3FtabId%3D22%26refresh%3D1%26ch%3D005162';

export const ACCOUNT_TYPE = {
  QQ: 1,
  WEIXIN: 2,
  QQUNION: 4,
  PHONE: 6,
};

export const isDev = process.env.isTest || process.env.NODE_ENV === 'development';
export const ugpageHost = isDev ? 'https://testugpage.html5.qq.com' : 'https://ugpage.html5.qq.com';
export const createSessionHost = isDev ? 'https://qblogin.sparta.html5.qq.com' : 'https://qblogin.kandian.qq.com';
export const kdILiveHost = isDev ? 'https://test.kd.ilive.qq.com' : 'https://kd.ilive.qq.com';
export const tencentLiveHost = isDev ? 'https://test.tencentlive.qq.com' : 'https://ias1.tencentlive.qq.com';
